module.exports={
	"Form": "LocationViewManifest",
	"Descriptors": {
		"LocationDetails.Name": {
			"Name": "Name",
			"Hash": "ViewLocationName",
			"DataType": "String",
			"PictForm": {
				"Row": "1",
				"Section": "LocationView",
				"Group": "LocationView"
			}
		},
		"LocationDetails.Description": {
			"Name": "Description",
			"Hash": "ViewLocationDescription",
			"DataType": "String",
			"PictForm": {
				"Row": "2",
				"Section": "LocationView",
				"Group": "LocationView"
			}
		},
		"LocationDetails.QRCode": {
			"Name": "QR Code",
			"Hash": "ViewLocationQRCode",
			"DataType": "String",
			"PictForm": {
				"Row": "1",
				"Section": "LocationView",
				"Group": "LocationView"
			}
		},
		"LocationDetails.ParentIDLocation": {
			"Name": "Linked To",
			"Hash": "ViewLocationParentIDLocation",
			"DataType": "String",
			"PictForm": {
				"Row": "2",
				"InputType": "Picker",
				"Section": "LocationView",
				"Group": "LocationView",
				"Entity": "Location"
			}
		}
	},
	"Sections": [
		{
			"Name": "Location View",
			"Hash": "LocationView",
			"Solvers": [],
			"ShowTitle": false,
			"Groups": [
				{
					"Name": "Location View",
					"Hash": "LocationView",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
